module.exports = __webpack_public_path__ + "static/media/Greenhouse_Premier.0653121e.png";